import Plugin from '../Plugin'


export default class Get extends Plugin {

    constructor(network) {
        super(network)
        this.events = {
            'get_player': this.getPlayer.bind(this)
        }
    }

    getPlayer(args) {
        this.interface.main.playerCard.updatePlayer(args.penguin)
    }

}
